<template>
  <div class="corporation-content zblock">
    <!-- Left content Big Image -->
    <div class="corporation__left-content" :style="windowWidth >= 1100 ? backgroundStyles : ''">
    </div>

    <!-- Right content Title Pictos and text-->
    <div class="corporation__right-content">
        <h4 class="block__title" :inner-html.prop="blockdatas.title"></h4>

        <ul>
            <li v-for="(paragraphe, key) in blockdatas.paragraphes" :key="key">
            <div class="paragraphe-container" v-if="paragraphe.subtitle !== ''">
                <div class="paragraphe__picto">
                <img :src="`${baseUrl}media/${paragraphe.picto}`" alt="picto" />
                </div>
                <div class="paragraphe__text">
                <strong :inner-html.prop="paragraphe.subtitle"></strong>
                <p class="paragraphe__paragraphe" :inner-html.prop="paragraphe.paragraphe"></p>
                </div>
            </div>
            </li>
        </ul>

        <a 
            :href="`${baseUrl}${blockdatas.link}`" 
            class="Button corporation__cta"
            target="blank"
            :inner-html.prop="blockdatas.button_text"
        ></a>
    </div>
  </div>
</template>

<script>
export default {
    name: "CorporationBlock",

    props: ["blockdatas"],

    data() {
        return {
        baseUrl: process.env.VUE_APP_API_BASE_URL + "/",
        windowWidth : window.innerWidth,
        };
    },

    computed: {
            backgroundStyles() {
                return {
                    "background-image": `url(${this.blockdatas.background_desktop})`,
                    "background-size": "cover",
                    "background-position": "center",
                };
            },
        },

    methods: {
        onResize() {
            this.windowWidth = window.innerWidth;
        },
    },

    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        })
    },

    beforeDestroy() { 
        window.removeEventListener('resize', this.onResize); 
    },

};
</script>

<style lang="scss" scoped>
.corporation-content {
  background-color: $color-red;
  padding: 5%;
  color: $color-white;
  margin: 100px auto;
  display: flex;
  justify-content: space-around;
  

  @media ($mq-from-tablet){
    max-width: 700px;
    border-radius: 7px;
  }

  @media ($mq-desktop) {
    max-width: 980px;
  }

  /* -----------------
        RIGHT CONTENT 
    ------------------ */
    .corporation__right-content {
        max-width: 400px;

        li {
        margin: 20px 0;
        }

        .block__title {
        font-family: $font-family-base;
        font-size: 2.6rem;
        color: $color-white;
        }

        .paragraphe-container {
            display: flex;

            .paragraphe__text {
                padding: 5%;
            }

            .paragraphe__picto {
                align-self: center;
                width: 40px;
                height: 40px;
                min-width: 40px;

                img {
                width: 100%;
                }
            }

            strong {
                font-weight: 700;
            }
        }

        .corporation__cta {
            display: block;
            max-width: 50%;
            text-align: center;
            background: $color-white;
            border-color: transparent;
            margin: 0 auto;

            @media ($mq-from-tablet) {
                margin: 0;
            }

            &:hover {
                background: transparent;
                color: $color-white;
                border-color: $color-white;
            }
        }
    }

  /* -----------------
        LEFT CONTENT 
    ------------------ */
  .corporation__left-content {
    display: none;

    
    @media ($mq-desktop) {
        display: block;
        width: 420px;
        overflow: hidden;
        margin-left: -15%;
        margin-right: 20px;
        border-radius: 7px;
    }

    @media ($mq-large-desktop) {
        margin-left: -25%;
    }

    img {
      max-width: none;
      height: 100%;
    }
  }
}
</style>
